// extracted by mini-css-extract-plugin
export var actions = "_u7-4";
export var item = "_u7-1";
export var price = "_u7-3";
export var quantity = "_u7-2";
export var table = "_u7-0";